// 截取字符串长度
export function substr (input, start = 0, length = 10) {
  return input && input.substr(start, length)
}

// 字符串超长缩略
export function ellipsis (input, length = 15) {
  if (!input) return ''
  if (input.length > length) {
    return substr(input, 0, length) + '...'
  }
  return input
}

export function clearHtml (input) {
  if (!input) return ''
  return input.replace(/<br>/gi, '')
}

export default {
  substr,
  ellipsis,
  clearHtml
}
